import React, { useState } from 'react';
import waterAnalytics from '../img/water-analytics.webp';
import firstwaterAnalytics from '../img/water-analytics-1.webp';
import secondwaterAnalytics from '../img/water-analytics-2.webp';
import thirdwaterAnalytics from '../img/water-analytics-3.webp';
import fourthwaterAnalytics from '../img/water-analytics-4.webp';

import waa from '../img/WAA-6-Stage-ft.webp';
import firstwaa from '../img/WAA-6-Stage-1.webp';
import secondwaa from '../img/WAA-6-Stage-2.webp';
import thirdwaa from '../img/WAA-6-Stage-3.webp';
import fourthwaa from '../img/WAA-6-Stage-4.webp';
import sixthwaa from '../img/WAA-6-Stage-6.webp';

import GetQuoteForm from './GetQuoteForm';

const PRODUCT_LABELS = {
  bundle: 'Full Home + Reverse Osmosis System',
  'full-home': 'Full Home Water Purifier System',
  ro: 'WAA 6-Stage Reverse Osmosis Water Filtration System',
};

const ProductLeft = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteProduct, setQuoteProduct] = useState('full-home');

  const openQuoteForm = (productId) => {
    setQuoteProduct(productId);
    setQuoteOpen(true);
  };

  const images = [firstwaterAnalytics, secondwaterAnalytics, thirdwaterAnalytics, fourthwaterAnalytics];
  const images_1 = [firstwaa, secondwaa, thirdwaa, fourthwaa, sixthwaa];

  return (
    <section className="section-4">
      <div className="container wide">
        <div className="title-subtitle">
          <h3 className='title'>Shop Water Filter Products</h3>
          <p className='desc'>Experience the difference of clean, filtered water for your entire home with our innovative systems.</p>
        </div>

        {/* ── Product 1: Bundle ── */}
        <div id="product-bundle" className="d-flex wf-prod-space right">
          <div className="product-images">
            <div className="main-image">
              <img id="main-img-bundle" src={waterAnalytics} alt="Full Home + Reverse Osmosis Bundle" />
            </div>
            <div className="thumbnail-gallery">
              {[...images, waa].map((img, index) => (
                <img key={index} src={img} alt={`Thumbnail ${index + 1}`} />
              ))}
            </div>
          </div>

          <div className="product-details">
            <h4 className="product-title">Full Home + Reverse Osmosis System</h4>
            <div className="rating">
              <div className="stars">★★★★★</div>
              <h5 className="rating-text">(5 stars) • 186 reviews</h5>
            </div>
            <div className='product-description'>
              <p className='desc'>
                Get complete water filtration throughout your home, plus ultra-purified drinking water at your kitchen tap.
              </p>
              <p className='desc'>
                This system pairs a full home filtration unit at the point of entry with a 6-stage reverse osmosis system under your sink. The result is cleaner water for every tap, shower, and appliance—plus advanced purification for drinking, cooking, and sensitive uses.
              </p>
              <p className='desc'>
                The whole home system reduces sediment, chlorine, and everyday contaminants before water enters your home, helping protect your plumbing, improve taste, and enhance overall water quality.
              </p>
              <p className='desc'>
                At the same time, the under-sink reverse osmosis system provides high-level filtration for drinking water, effectively reducing PFAs, fluoride, heavy metals, and dissolved solids—delivering crisp, clean, mineralised water straight from your tap.
              </p>
              <p className='desc'>
                This is the ideal solution for households wanting full coverage and the highest level of drinking water quality without compromise.
              </p>
            </div>

            <div className="buttons">
              <div className="compat-cta-wrap">
                <button
                  className="compat-cta-btn"
                  data-product-id="bundle"
                  onClick={() => openQuoteForm('bundle')}
                >
                  Get A Free Quote
                </button>
                <div className="compat-cta-meta">
                  <span>Free, no-obligation quote</span>
                  <span>Mitch will call you back</span>
                </div>
              </div>
              <a className="learn-btn" href="tel:1300631226">Call Now</a>
            </div>

            <div className="free-shipping">Free shipping over $50</div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_1" id="faq-drawer-bundle" type="checkbox" />
              <label className="faq-drawer__title_1" htmlFor="faq-drawer-bundle">Details</label>
              <div className="faq-drawer__content-wrapper_1">
                <div className="faq-drawer__content">
                  <p className='desc'><strong>Whole Home Filtration (Point of Entry)</strong></p>
                  <p className='desc'>Delivers clean, filtered water throughout your entire home—protecting plumbing, improving taste, and reducing everyday contaminants.</p>
                  <p className='desc'><strong>Sediment Filter:</strong> Advanced 3-layer filtration capturing particles down to 1 micron, removing dirt, rust, and sediment while maintaining strong water flow. Made from food-grade materials for safe, long-term use.</p>
                  <p className='desc'><strong>Heavy Metal Reduction &amp; Taste Improvement Filter:</strong> Utilises ZDF 55 and XNT 85 technology with natural coconut carbon to reduce heavy metals and improve taste, with a lifespan of up to 18 months.</p>
                  <p className='desc'><strong>Limescale Reduction Filter:</strong> Advanced media designed to reduce scale build-up more effectively than traditional systems, while maintaining fine filtration for cleaner, better-tasting water.</p>
                  <p className='desc'><strong>Reinforced Stainless Steel Frame:</strong> Engineered for durability, preventing pipe stress during filter changes and extending the overall lifespan of the system.</p>

                  <p className='desc' style={{marginTop: '12px'}}><strong>Advanced Drinking Water Filtration (Under-Sink RO System)</strong></p>
                  <p className='desc'>Provides ultra-purified water at your tap for drinking, cooking, and sensitive applications.</p>
                  <p className='desc'><strong>Polyspun Sediment Filter:</strong> Removes sand, silt, and rust to protect downstream filters and maintain system performance.</p>
                  <p className='desc'><strong>Chemical Reduction Filter:</strong> Targets pesticides, herbicides, and volatile organic compounds (VOCs), improving water safety.</p>
                  <p className='desc'><strong>Chlorine &amp; Bacteria Reduction Filter:</strong> Reduces chlorine, chloramine, and disinfection by-products while limiting bacterial growth.</p>
                  <p className='desc'><strong>Multi-Stage RO Filtration:</strong> Removes dissolved solids, heavy metals, fluoride, and PFAs for high-purity drinking water.</p>
                  <p className='desc'><strong>Mineralisation &amp; Alkalisation Stages:</strong> Enhances taste by reintroducing beneficial minerals, delivering clean, balanced water.</p>
                </div>
              </div>
            </div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_1" id="faq-drawer-bundle-2" type="checkbox" />
              <label className="faq-drawer__title_1" htmlFor="faq-drawer-bundle-2">Installation Included</label>
              <div className="faq-drawer__content-wrapper_1">
                <div className="faq-drawer__content">
                  <p className='desc'>We offer free installation by a licensed plumber.</p>
                </div>
              </div>
            </div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_1" id="faq-drawer-bundle-3" type="checkbox" />
              <label className="faq-drawer__title_1" htmlFor="faq-drawer-bundle-3">Returns</label>
              <div className="faq-drawer__content-wrapper_1">
                <div className="faq-drawer__content">
                  <p className='desc'>
                    If you're not completely satisfied with your purchase, we offer a hassle-free return policy. Return your item within 30 days for a full refund. Customer satisfaction is our top priority.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Product 2: Full Home ── */}
        <div id="product-full-home" className="d-flex wf-prod-space">
          <div className="product-images">
            <div className="main-image">
              <img id="main-img" src={waterAnalytics} alt="Full Home Water Purifier System" />
            </div>
            <div className="thumbnail-gallery">
              {images.map((img, index) => (
                <img key={index} src={img} alt={`Thumbnail ${index + 1}`} />
              ))}
            </div>
          </div>

          <div className="product-details">
            <h4 className="product-title">Full Home Water Purifier System</h4>
            <div className="rating">
              <div className="stars">★★★★★</div>
              <h5 className="rating-text">(5 stars) • 186 reviews</h5>
            </div>
            <div className='product-description'>
              <p className='desc'>
                The Whole House Water Filtration System (FHWR-3S1-20) by Water Analytics provides comprehensive water purification right at the point of entry, ensuring clean, contaminant-free water flows throughout your entire home. Designed for durability and efficiency, this system features a combination of advanced filters and heavy-duty components to guarantee optimal water quality and system longevity.
              </p>
              <p className='desc'>
                The WAA Reverse Osmosis Water Filtration System (USRO-3S1-2W) offers advanced, multi-stage purification to deliver pure, mineralised, and alkaline water right at your tap. Designed for optimal contaminant removal, this RO system is highly effective at filtering out PFAs, fluoride, radium, barium, and other dissolved solids (TDS), making it ideal for sensitive applications like baby formula preparation, CPAP machines, and overall PFA risk reduction.
              </p>
            </div>

            <div className="buttons">
              <div className="compat-cta-wrap">
                <button
                  className="compat-cta-btn"
                  data-product-id="full-home"
                  onClick={() => openQuoteForm('full-home')}
                >
                  Get A Free Quote
                </button>
                <div className="compat-cta-meta">
                  <span>Free, no-obligation quote</span>
                  <span>Mitch will call you back</span>
                </div>
              </div>
              <a className="learn-btn" href="tel:1300631226">Call Now</a>
            </div>

            <div className="free-shipping">Free shipping over $50</div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_1" id="faq-drawer" type="checkbox" />
              <label className="faq-drawer__title_1" htmlFor="faq-drawer">Details</label>
              <div className="faq-drawer__content-wrapper_1">
                <div className="faq-drawer__content">
                  <p className='desc'>
                    Sediment Filter: Utilising advanced 3-layer technology, this filter captures particles down to 1 micron, effectively removing sediment and ensuring optimal water flow. Made from food-grade materials, it provides a safe, long-lasting solution for sediment filtration.
                  </p>
                  <p className='desc'>
                    Heavy Metal Reduction & Taste Improvement Filter: Featuring ZDF 55 and XNT 85 technology, this carbon filter efficiently reduces heavy metals, improving water taste and safety. Its natural coconut carbon structure adds longevity, lasting up to 18 months.
                  </p>
                  <p className='desc'>
                    Limescale Reduction Filter: Incorporates advanced limescale reduction media, offering more efficient filtration than traditional methods. Achieves up to 1-micron filtration accuracy, providing purer, better-tasting water.
                  </p>
                  <p className='desc'>
                    Stainless Steel Frame and Housing Enforce Plate: Reinforced to prevent pipe breakage during filter changes, this frame offers superior durability compared to plastic-only structures, extending the system's lifespan.
                  </p>
                </div>
              </div>
            </div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_1" id="faq-drawer-2" type="checkbox" />
              <label className="faq-drawer__title_1" htmlFor="faq-drawer-2">Installation Included</label>
              <div className="faq-drawer__content-wrapper_1">
                <div className="faq-drawer__content">
                  <p className='desc'>We offer free installation by a licensed plumber.</p>
                </div>
              </div>
            </div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_1" id="faq-drawer-3" type="checkbox" />
              <label className="faq-drawer__title_1" htmlFor="faq-drawer-3">Returns</label>
              <div className="faq-drawer__content-wrapper_1">
                <div className="faq-drawer__content">
                  <p className='desc'>
                    If you're not completely satisfied with your purchase, we offer a hassle-free return policy. Return your item within 30 days for a full refund. Customer satisfaction is our top priority.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Product 2: RO System ── */}
        <div id="product-ro" className="d-flex wf-prod-space right">
          <div className="product-images">
            <div className="main-image">
              <img id="main-img-2" src={waa} alt="WAA 6-Stage Reverse Osmosis System" />
            </div>
            <div className="thumbnail-gallery">
              {images_1.map((img, index) => (
                <img key={index} src={img} alt={`Thumbnail ${index + 1}`} />
              ))}
            </div>
          </div>

          <div className="product-details">
            <h4 className="product-title">WAA 6-Stage Reverse Osmosis Water Filtration System</h4>
            <div className="rating">
              <div className="stars">★★★★★</div>
              <h5 className="rating-text">(5 stars) • 186 reviews</h5>
            </div>
            <div className='product-description'>
              <p className='desc'>
                The WAA 6-Stage Reverse Osmosis (RO) Water Filtration System offers comprehensive water purification in a compact, electricity-free design, making it an ideal solution for those renting or living in apartments. This versatile under-sink system delivers mineralised and alkalised water without the need for permanent installation, ensuring access to clean, fresh water wherever you live.
              </p>
            </div>

            <div className="buttons">
              <div className="compat-cta-wrap">
                <button
                  className="compat-cta-btn"
                  data-product-id="ro"
                  onClick={() => openQuoteForm('ro')}
                >
                  Get A Free Quote
                </button>
                <div className="compat-cta-meta">
                  <span>Free, no-obligation quote</span>
                  <span>Mitch will call you back</span>
                </div>
              </div>
              <a className="learn-btn" href="tel:1300631226">Call Now</a>
            </div>

            <div className="free-shipping">Free shipping over $50</div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_2" id="faq-drawer-4" type="checkbox" />
              <label className="faq-drawer__title_2" htmlFor="faq-drawer-4">Details</label>
              <div className="faq-drawer__content-wrapper_2">
                <div className="faq-drawer__content">
                  <p className='desc'>Key Filtration Stages:</p>
                  <ol>
                    <li className='desc'>Polyspun Sediment Filter: Made from high-quality polypropylene fibres, this first-stage filter removes sand, silt, rust, and other particulates, protecting and extending the lifespan of the filters that follow.</li>
                    <li className='desc'>Chemical Reduction Filter: This second stage effectively reduces harmful chemicals, such as pesticides, herbicides, and volatile organic compounds (VOCs), which can negatively impact health if ingested or inhaled.</li>
                    <li className='desc'>Chlorine and Bacteria Reduction Filter: Designed to target chlorine, chloramine, and trihalomethanes (THMs), this third-stage filter reduces bacterial growth and improves overall water quality by removing disinfectants and their by-products.</li>
                  </ol>
                  <p className='desc'>
                    With additional stages for mineralisation and alkalisation, this RO system enhances both the taste and purity of your water, ensuring a safer, more enjoyable drinking experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_2" id="faq-drawer-5" type="checkbox" />
              <label className="faq-drawer__title_2" htmlFor="faq-drawer-5">Installation Included</label>
              <div className="faq-drawer__content-wrapper_2">
                <div className="faq-drawer__content">
                  <p className='desc'>We offer free installation by a licensed plumber.</p>
                </div>
              </div>
            </div>

            <div className="faq-drawer">
              <input className="faq-drawer__trigger_2" id="faq-drawer-6" type="checkbox" />
              <label className="faq-drawer__title_2" htmlFor="faq-drawer-6">Returns</label>
              <div className="faq-drawer__content-wrapper_2">
                <div className="faq-drawer__content">
                  <p className='desc'>
                    If you're not completely satisfied with your purchase, we offer a hassle-free return policy. Return your item within 30 days for a full refund. Customer satisfaction is our top priority.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetQuoteForm
        isOpen={quoteOpen}
        onClose={() => setQuoteOpen(false)}
        productId={quoteProduct}
        productLabel={PRODUCT_LABELS[quoteProduct]}
      />
    </section>
  );
};

export default ProductLeft;
